export default __webpack_public_path__ + "static/media/company2.ee2681fe.svg";